export const HEALTH_STATUS = {
  healthy: {
    label: 'Healthy',
    color: '#22C55E',
    backgroundColor: '#DCFCE7',
  },
  attention: {
    label: 'Needs attention',
    color: '#F59E42',
    backgroundColor: '#FEF3C7',
  },
  critical: {
    label: 'Critical',
    color: '#EF4444',
    backgroundColor: '#FEE2E2',
  },
  no_cache: {
    label: 'No cache data',
    color: '#EF4444',
    backgroundColor: '#FEE2E2',
  },
};

export const HEALTH_THRESHOLDS = {
  criticalNotUpdatedPct: 50,
  attentionNotUpdatedPct: 30,
  criticalMappedPct: 80,
  attentionMappedPct: 95,
  problemBannerPct: 70,
  problemPmgPct: 50,
};

export function getHealthStatusStyle(status) {
  return HEALTH_STATUS[status] || HEALTH_STATUS.no_cache;
}

export function formatHealthDate(isoString) {
  if (!isoString) return '—';
  return new Date(isoString).toLocaleString();
}

export function formatScopeRatio(withData, configured) {
  if (configured == null || configured === 0) {
    return String(withData ?? 0);
  }
  return `${withData ?? 0}/${configured}`;
}

export function buildOodReportUrl(userTypeId, projectId) {
  return `/company-report-tool-out-of-date/${userTypeId}/${projectId}`;
}
